// /set-password: set your own password from a link an admin sent.
// Thin composer: the page lives in features/auth/SetPassword.tsx.
import { SetPassword } from "@/features/auth/SetPassword";

export function SetPasswordPage() {
  return <SetPassword />;
}
